import { CloseOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";
import { useTranslation } from "react-i18next";
import "../styles/card.scss";

export interface BaseDrawerProps {
  title: string;
  dataTestId?: string;
  drawerVisible: boolean;
  children?: React.ReactNode;
  onCloseDrawer: (visible: boolean) => void;
  afterOpenChange?: (...args: any[]) => any;
}

export function BaseDrawer({
  title,
  drawerVisible,
  children,
  dataTestId,
  onCloseDrawer,
  afterOpenChange,
}: BaseDrawerProps) {
  const { t } = useTranslation();
  return (
    <Drawer
      bodyStyle={{ margin: "1.5rem", padding: "0px" }}
      title={
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          data-testid={dataTestId}
        >
          <span>{title}</span>
          <Button
            type="text"
            className="close-card-drawer-button"
            icon={<CloseOutlined />}
            onClick={() => onCloseDrawer(false)}
          />
        </div>
      }
      placement="right"
      closable={false}
      onClose={() => onCloseDrawer(false)}
      afterOpenChange={afterOpenChange}
      open={drawerVisible}
      width="70%"
    >
      {children}
    </Drawer>
  );
}
